/* Adviespaneel voor alle adviesknoppen (snippets/advice-panel.liquid; BLOK-W "Adviespaneel voor ALLE adviesknoppen").
   - Elke knop met data-advice-context opent hetzelfde paneel: hoesje, screenprotector, iphone, opladen of algemeen.
   - Per context: titel, contextkaart, 4 vraagchips (de eerste staat aan), voorgevuld bericht en 3 FAQ-links naar bestaande antwoorden.
   - Er wordt niets opgeslagen of verstuurd: de verstuurknop is een gewone link naar wa.me of mailto met het bericht erin.
   - Het model in het bericht komt uit de bestaande modelkeuze (?pf_model= of de opgeslagen pf-device); anders een open plek "…".
   - FAQ-links eindigen op #pf-faq=<vraag>; op de doelpagina klapt deze code die vraag open. */
(function () {
  'use strict';
  var dlg = document.getElementById('pf-advice-panel');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  function readJson(sel) { var n = document.querySelector(sel); if (!n) return null; try { return JSON.parse(n.textContent); } catch (e) { return null; } }
  var cfg = readJson('[data-advice-config]') || {};
  var prod = readJson('[data-advice-product-data]');
  var $ = function (sel) { return dlg.querySelector(sel); };
  var OPEN = '…';
  var KS = '/pages/contact?view=';
  var FAQ = {
    acc: ['/pages/contact?view=accessoires', 'Veelgestelde vragen over accessoires'],
    garantie: [KS + 'klantenservice-garantie', 'Garantie & service'],
    retour: [KS + 'klantenservice-retourneren', 'Retourneren & herroepen'],
    contact: [KS + 'klantenservice-contact', 'Klantenservice'],
    conditie: ['/pages/conditie', 'Productcondities']
  };
  var ICONS = {
    phone: '<rect x="7" y="2.5" width="10" height="19" rx="2.5"/><path d="M11 18.5h2"/>',
    palette: '<path d="M12 3a9 9 0 1 0 0 18c1 0 1.6-.8 1.6-1.6 0-.5-.2-.8-.5-1.2-.3-.3-.5-.7-.5-1.2 0-.9.7-1.6 1.6-1.6H16a5 5 0 0 0 5-5c0-4-4-7.4-9-7.4Z"/><circle cx="7.5" cy="11" r="1"/><circle cx="10" cy="7" r="1"/><circle cx="14.5" cy="7" r="1"/>',
    magnet: '<path d="M6 3v8a6 6 0 0 0 12 0V3"/><path d="M6 7h4M14 7h4M10 3v8a2 2 0 0 0 4 0V3"/>',
    layers: '<path d="m12 3 9 5-9 5-9-5 9-5Z"/><path d="m3 13 9 5 9-5"/>',
    eye: '<path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Z"/><circle cx="12" cy="12" r="3"/>',
    shield: '<path d="M12 3 5 6v5c0 4.5 3 8.3 7 10 4-1.7 7-5.5 7-10V6l-7-3Z"/>',
    help: '<circle cx="12" cy="12" r="9"/><path d="M9.5 9.5a2.5 2.5 0 0 1 4.9.7c0 1.7-2.4 2.2-2.4 3.8"/><path d="M12 17h.01"/>',
    battery: '<rect x="2.5" y="7" width="17" height="10" rx="2"/><path d="M22 11v2M6 10v4M9.5 10v4"/>',
    storage: '<rect x="3" y="4" width="18" height="16" rx="2"/><path d="M3 10h18M7 14h4"/>',
    plug: '<path d="M9 2v5M15 2v5M6 7h12v4a6 6 0 0 1-12 0V7Z"/><path d="M12 17v5"/>',
    bolt: '<path d="M13 2 4 14h7l-1 8 9-12h-7l1-8Z"/>',
    cable: '<path d="M7 3v4M17 3v4M5 7h4v4H5zM15 7h4v4h-4zM7 11v3a5 5 0 0 0 10 0v-3"/><path d="M12 19v3"/>',
    box: '<path d="m3 7 9-4 9 4v10l-9 4-9-4V7Z"/><path d="m3 7 9 4 9-4M12 11v10"/>',
    holder: '<rect x="7.5" y="3" width="9" height="14.5" rx="2"/><path d="M4.5 7.5h3M4.5 13h3M4.5 7.5V13M19.5 7.5h-3M19.5 13h-3M19.5 7.5V13M12 17.5V21M9 21h6"/>'
  };
  function svg(name, size) { return '<svg width="' + (size || 18) + '" height="' + (size || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || ICONS.help) + '</svg>'; }

  /* Chips: [icoon, label, bericht zonder product, bericht met product]. Tokens: {item} {model} {noun} {cat}. */
  var CTX = {
    hoesje: {
      title: 'Advies over je hoesje', choice: 'Hoesje', card: ['Hoesjes', 'Categorie'], subject: 'Vraag over een hoesje',
      chips: [
        ['phone', 'Past het op mijn toestel?', 'Welk hoesje past op mijn iPhone? Mijn toestel is {model}.', 'Past {item} op mijn iPhone? Mijn toestel is {model}.'],
        ['palette', 'Welke kleur past?', 'Ik twijfel over de kleur van mijn hoesje. Wat raden jullie aan? Mijn toestel is {model}.', 'Ik twijfel over de kleur van {item}. Wat raden jullie aan?'],
        ['magnet', 'MagSafe & opladen', 'Werkt MagSafe en draadloos opladen met een hoesje? Mijn toestel is {model}.', 'Werkt MagSafe en draadloos opladen met {item}? Mijn toestel is {model}.'],
        ['layers', 'Backcover of wallet?', 'Ik twijfel tussen een backcover en een wallet. Wat raden jullie aan? Mijn toestel is {model}.']
      ],
      faq: [['acc', 'Past een hoesje van de iPhone 15 Pro op de 15 Pro Max?'], ['acc', 'Hoe weet ik welk accessoire op mijn iPhone past?'], ['acc', 'Kan ik een accessoire retourneren?']]
    },
    screenprotector: {
      title: 'Advies over screenprotectors', choice: 'Screenprotector', card: ['Screenprotectors', 'Categorie'], subject: 'Vraag over een screenprotector',
      chips: [
        ['phone', 'Welk glas past op mijn toestel?', 'Welk glas past op mijn iPhone? Mijn toestel is {model}.', 'Past {item} op mijn iPhone? Mijn toestel is {model}.'],
        ['eye', 'Privacy of gewoon glas?', 'Ik twijfel tussen privacyglas en gewoon glas. Wat raden jullie aan? Mijn toestel is {model}.'],
        ['shield', 'Ultra Wide Fit of Ceramic?', 'Wat is het verschil tussen Ultra Wide Fit en Ceramic? Mijn toestel is {model}.'],
        ['help', 'Hulp bij plaatsen', 'Ik wil graag hulp bij het plaatsen van mijn screenprotector. Mijn toestel is {model}.', 'Ik wil graag hulp bij het plaatsen van {item}.']
      ],
      faq: [['acc', 'Hoe weet ik welk accessoire op mijn iPhone past?'], ['retour', 'Hoe zit het met screenprotectors?'], ['garantie', 'Heb ik garantie op kabels en screenprotectors?']]
    },
    iphone: {
      title: 'Advies over je iPhone', choice: 'Refurbished iPhone', card: ['Refurbished iPhones', 'Categorie'], subject: 'Vraag over Refurbished iPhones',
      chips: [
        ['phone', 'Welke iPhone past bij mij?', 'Ik twijfel welke iPhone bij mij past. Ik gebruik hem vooral voor ' + OPEN, 'Ik twijfel of de {item} bij mij past. Ik gebruik hem vooral voor ' + OPEN],
        ['battery', 'Batterij en conditie', 'Ik heb een vraag over de batterij en de conditie van jullie refurbished iPhones: ' + OPEN, 'Ik heb een vraag over de batterij en de conditie van de {item}: ' + OPEN],
        ['storage', 'Hoeveel opslag heb ik nodig?', 'Hoeveel opslag heb ik nodig? Ik gebruik mijn iPhone vooral voor ' + OPEN, 'Hoeveel opslag heb ik nodig bij de {item}? Ik gebruik mijn iPhone vooral voor ' + OPEN],
        ['shield', 'Garantie en retour', 'Ik heb een vraag over garantie en retour: ' + OPEN, 'Ik heb een vraag over garantie en retour bij de {item}: ' + OPEN]
      ],
      faq: [['conditie', 'Is er verschil in garantie tussen de condities?'], ['garantie', 'Hoe lang heb ik garantie?'], ['contact', 'Hoe meld ik een retour aan?']]
    },
    opladen: {
      title: 'Advies over opladen', choice: 'Kabels, laders en powerbanks', card: ['Kabels, laders en powerbanks', 'Categorie'], subject: 'Vraag over opladen',
      chips: [
        ['plug', 'Welke past op mijn toestel?', 'Welke {noun} past op mijn iPhone? Mijn toestel is {model}.', 'Past {item} op mijn iPhone? Mijn toestel is {model}.'],
        ['bolt', 'Hoeveel watt heb ik nodig?', 'Hoeveel watt heb ik nodig om mijn iPhone snel op te laden? Mijn toestel is {model}.', 'Hoeveel watt heb ik nodig? Ik kijk naar {item}. Mijn toestel is {model}.'],
        ['cable', 'USB-C of Lightning?', 'Heeft mijn iPhone USB-C of Lightning nodig? Mijn toestel is {model}.'],
        ['help', 'Iets anders', 'Ik heb een vraag over {cat}: ' + OPEN, 'Ik heb een vraag over {item}: ' + OPEN]
      ],
      faq: [['acc', 'Welke kabel heb ik nodig?'], ['acc', 'Zit er een lader bij een refurbished iPhone van PrimeFone?'], ['garantie', 'Heb ik garantie op kabels en screenprotectors?']]
    },
    algemeen: {
      title: 'Stel je vraag', choice: 'Algemene vraag', card: ['Algemene vraag', 'Over een bestelling, product of service'], subject: 'Vraag aan PrimeFone',
      chips: [
        ['phone', 'Welk product past?', 'Ik zoek een product voor mijn iPhone en twijfel wat past. Mijn toestel is {model}.'],
        ['box', 'Over mijn bestelling', 'Ik heb een vraag over mijn bestelling. Mijn bestelnummer is ' + OPEN],
        ['shield', 'Garantie of retour', 'Ik heb een vraag over garantie of retour: ' + OPEN],
        ['help', 'Iets anders', 'Ik heb een vraag over ' + OPEN]
      ],
      faq: [['contact', 'Hoe meld ik een retour aan?'], ['garantie', 'Hoe lang heb ik garantie?'], ['retour', 'Wanneer krijg ik mijn geld terug?']]
    }
  };
  var ORDER = ['hoesje', 'screenprotector', 'iphone', 'opladen', 'algemeen'];

  var state = { ctx: 'algemeen', origin: null, chip: 0, trigger: null };
  var text = $('[data-adv-text]'), send = $('[data-adv-send]');

  function storedModel() {
    try { var p = new URLSearchParams(location.search).getAll('pf_model'); if (p.length === 1 && p[0]) return p[0]; } catch (e) { /* geen URL-API */ }
    try { return localStorage.getItem('pf-device') || ''; } catch (e) { return ''; }
  }
  function currentVariant() {
    if (!prod || !prod.variants) return null;
    var id = '';
    try { id = new URLSearchParams(location.search).get('variant') || ''; } catch (e) { /* geen URL-API */ }
    if (!prod.variants[id]) { var f = document.querySelector('form[action*="/cart/add"] [name="id"]'); id = f ? String(f.value) : String(prod.current); }
    return prod.variants[id] ? prod.variants[id] : prod.variants[String(prod.current)] || null;
  }
  function countFrom(sel) {
    if (!sel) return '';
    try { var n = document.querySelector(sel); var m = n && n.textContent.replace(/\./g, '').match(/\d+/); return m ? m[0] : ''; } catch (e) { return ''; }
  }

  /* Gegevens van de knop vastleggen bij het openen (de oorsprong); "Wijzig" kan daarna een andere context kiezen. */
  function readTrigger(t) {
    var d = t.dataset, ctx = CTX[d.adviceContext] ? d.adviceContext : 'algemeen';
    var o = { ctx: ctx, name: d.adviceName || '', sub: d.adviceSub || '', item: d.adviceItem || '', model: d.adviceModel || '', img: d.adviceImage || '', icon: d.adviceIcon || '', noun: d.adviceNoun || '', cat: d.adviceCat || '' };
    if (d.adviceProduct != null && prod) {
      var v = currentVariant(), vt = v && v.t && v.t !== 'Default Title' ? v.t : '';
      o.name = o.name || prod.title;
      o.img = o.img || (v && v.i) || prod.image || '';
      var bits = [];
      if (o.model) bits.push('Voor ' + o.model); else if (o.sub) bits.push(o.sub); else if (vt && o.name.indexOf(vt) < 0) bits.push(vt);
      if (v && v.p) bits.push(v.p);
      o.sub = bits.join(' · ');
      o.item = o.item || (prod.title + (vt && prod.title.indexOf(vt) < 0 ? ' (' + vt + ')' : ''));
      o.product = true;
    } else if (!o.sub && o.name) {
      var c = countFrom(d.adviceCount);
      o.sub = 'Categorie' + (c ? ' · ' + c + ' ' + (d.adviceCountNoun || 'producten') : '');
    }
    return o;
  }
  function card(o) {
    var def = CTX[o.ctx];
    var name = o.name || def.card[0], sub = o.sub || def.card[1];
    $('[data-adv-ctx-name]').textContent = name;
    $('[data-adv-ctx-sub]').textContent = sub;
    var box = $('[data-adv-ctx-img]'), src = o.img || (cfg.img && cfg.img[o.ctx]) || '';
    box.textContent = '';
    if (src) { var im = new Image(); im.src = src; im.alt = ''; im.width = 56; im.height = 56; im.decoding = 'async'; box.appendChild(im); box.classList.remove('is-icon'); }
    else { box.innerHTML = svg(ICONS[o.icon] ? o.icon : 'help', 26); box.classList.add('is-icon'); } // data-advice-icon: categorie zonder goedgekeurde foto
  }
  function fill(tpl, o) {
    var model = storedModel() || OPEN;
    var defNoun = o.ctx === 'opladen' ? 'kabel of lader' : 'accessoire';
    return 'Hoi PrimeFone! ' + tpl.replace(/\{item\}/g, o.item || '').replace(/\{model\}/g, model).replace(/\{noun\}/g, o.noun || defNoun).replace(/\{cat\}/g, o.cat || 'opladen')
      .replace(/…\./g, OPEN);
  }
  function current() { return state.origin && state.origin.ctx === state.ctx ? state.origin : { ctx: state.ctx }; }
  function message() {
    var o = current(), chip = CTX[o.ctx].chips[state.chip];
    var tpl = o.product && o.item && chip[3] ? chip[3] : chip[2];
    return fill(tpl, o);
  }
  function subject() {
    var o = current();
    if (o.product && o.name) return 'Vraag over ' + o.name;
    if (o.name && o.ctx !== 'algemeen') return 'Vraag over ' + o.name;
    return CTX[o.ctx].subject;
  }
  function channel() { var c = dlg.querySelector('input[name="pfadv-channel"]:checked'); return c ? c.value : 'email'; }

  function renderChips() {
    var box = $('[data-adv-chips]'), def = CTX[state.ctx];
    box.textContent = '';
    def.chips.forEach(function (c, i) {
      var l = document.createElement('label'); l.className = 'pfadv__chip';
      var r = document.createElement('input'); r.type = 'radio'; r.name = 'pfadv-chip'; r.value = String(i); r.checked = i === state.chip;
      var s = document.createElement('span'); s.className = 'pfadv__chip-ico'; s.innerHTML = svg(c[0], 18);
      var t = document.createElement('span'); t.textContent = c[1];
      l.append(r, s, t); box.appendChild(l);
    });
  }
  function renderFaq() {
    var ul = $('[data-adv-faq]'); ul.textContent = '';
    CTX[state.ctx].faq.forEach(function (f) {
      var li = document.createElement('li'), a = document.createElement('a'), page = FAQ[f[0]];
      a.href = page[0] + '#pf-faq=' + encodeURIComponent(f[1]);
      a.dataset.advFaqLink = '';
      a.innerHTML = svg('help', 16) + '<span></span><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';
      a.querySelector('span').textContent = f[1];
      a.title = page[1];
      li.appendChild(a); ul.appendChild(li);
    });
  }
  function renderCtxOptions() {
    var box = $('[data-adv-ctxopts]'); box.textContent = '';
    ORDER.forEach(function (k) {
      var l = document.createElement('label'); l.className = 'pfadv__ctxopt';
      var r = document.createElement('input'); r.type = 'radio'; r.name = 'pfadv-ctx'; r.value = k; r.checked = k === state.ctx;
      var t = document.createElement('span'); t.textContent = CTX[k].choice;
      l.append(r, t); box.appendChild(l);
    });
  }
  function grow() { text.style.height = 'auto'; text.style.height = Math.min(text.scrollHeight + 2, 220) + 'px'; }
  function build() {
    var ch = channel(), body = text.value.trim(), subj = subject();
    var wa = ch === 'whatsapp' && cfg.wa;
    dlg.classList.toggle('is-mail', !wa);
    $('[data-adv-mailhead]').hidden = !!wa;
    $('[data-adv-subject]').textContent = subj;
    $('[data-adv-meta]').hidden = !wa;
    $('[data-adv-send-label]').textContent = wa ? 'Verstuur via WhatsApp' : 'Verstuur via e-mail';
    $('[data-adv-send-ico-wa]').toggleAttribute('hidden', !wa); $('[data-adv-send-ico-mail]').toggleAttribute('hidden', !!wa); // SVG kent geen .hidden
    var nw = $('[data-adv-note-wa]'), nm = $('[data-adv-note-mail]');
    if (nw) nw.hidden = !wa; if (nm) nm.hidden = !!wa;
    if (wa) { send.href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(body); send.target = '_blank'; }
    else { send.href = 'mailto:' + cfg.mail + '?subject=' + encodeURIComponent(subj) + '&body=' + encodeURIComponent(body); send.removeAttribute('target'); }
  }
  function setContext(ctx) {
    state.ctx = ctx; state.chip = 0;
    $('[data-adv-title]').textContent = CTX[ctx].title;
    card(current());
    renderChips(); renderFaq();
    text.value = message(); grow(); build();
  }

  /* Openingstijden, bv. "ma-vr 09:00-17:30" per regel. Leeg of onleesbaar = geen status. */
  var DAYS = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
  function status() {
    var lines = String(cfg.hours || '').split(/\n|;/), rules = [];
    lines.forEach(function (l) {
      var m = l.trim().toLowerCase().match(/^(ma|di|wo|do|vr|za|zo)[a-z]*\.?(?:\s*(?:-|–|t\/m)\s*(ma|di|wo|do|vr|za|zo)[a-z]*\.?)?\s*:?\s*(\d{1,2})[:.](\d{2})\s*(?:-|–|tot)\s*(\d{1,2})[:.](\d{2})/);
      if (!m) return;
      var a = DAYS.indexOf(m[1]), b = m[2] ? DAYS.indexOf(m[2]) : a;
      rules.push({ a: a, b: b, from: +m[3] * 60 + +m[4], to: +m[5] * 60 + +m[6] });
    });
    if (!rules.length) return null;
    var parts = {};
    try { new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; }); } catch (e) { return null; }
    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(parts.weekday), min = +parts.hour * 60 + +parts.minute;
    var inDay = function (r) { return r.a <= r.b ? day >= r.a && day <= r.b : day >= r.a || day <= r.b; };
    return rules.some(function (r) { return inDay(r) && min >= r.from && min < r.to; });
  }
  function renderStatus() {
    var s = status(), el = $('[data-adv-status]'), dot = $('[data-adv-dot]');
    el.hidden = s === null; dot.hidden = s !== true;
    el.classList.toggle('is-open', s === true);
    el.textContent = s === true ? 'Nu bereikbaar' : 'We reageren zo snel mogelijk';
  }

  var lockPad = '';
  function open(trigger) {
    state.trigger = trigger || null;
    state.origin = trigger ? readTrigger(trigger) : { ctx: 'algemeen' };
    var want = trigger && trigger.dataset.adviceChannel;
    var opt = want && dlg.querySelector('input[name="pfadv-channel"][value="' + (want === 'email' ? 'email' : 'whatsapp') + '"]');
    var first = dlg.querySelector('input[name="pfadv-channel"]');
    if (opt) opt.checked = true; else if (cfg.wa && first) first.checked = true;
    $('[data-adv-ctxlist]').hidden = true; $('[data-adv-edit]').setAttribute('aria-expanded', 'false');
    renderStatus();
    setContext(state.origin.ctx);
    var sw = window.innerWidth - document.documentElement.clientWidth;
    lockPad = document.body.style.paddingRight;
    if (sw > 0) document.body.style.paddingRight = sw + 'px';
    document.documentElement.classList.add('pfadv-lock');
    dlg.showModal();
    grow(); // pas na het openen is de tekstvakhoogte meetbaar
    $('[data-adv-body]').scrollTop = 0;
    var c = dlg.querySelector('input[name="pfadv-chip"]:checked'); if (c) c.focus();
  }
  function close() { if (dlg.open) dlg.close(); }
  dlg.addEventListener('close', function () {
    document.documentElement.classList.remove('pfadv-lock');
    document.body.style.paddingRight = lockPad;
    var t = state.trigger; state.trigger = null;
    if (t && document.contains(t) && typeof t.focus === 'function') t.focus();
  });

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) { var r = dlg.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { close(); return; } }
    if (e.target.closest('[data-adv-close]')) { close(); return; }
    if (e.target.closest('[data-adv-edit]')) {
      var list = $('[data-adv-ctxlist]'), show = list.hidden;
      list.hidden = !show; e.target.closest('[data-adv-edit]').setAttribute('aria-expanded', String(show));
      if (show) { renderCtxOptions(); var r2 = list.querySelector('input:checked'); if (r2) r2.focus(); }
      return;
    }
    var f = e.target.closest('[data-adv-faq-link]');
    if (f) { var u = new URL(f.href, location.href); if (u.pathname === location.pathname && u.search === location.search) close(); }
  });
  dlg.addEventListener('change', function (e) {
    var n = e.target.name;
    if (n === 'pfadv-chip') { state.chip = +e.target.value; text.value = message(); grow(); build(); }
    else if (n === 'pfadv-channel') build();
    else if (n === 'pfadv-ctx') setContext(e.target.value);
  });
  /* Focus blijft in het paneel: Tab na het laatste element gaat naar het eerste, Shift+Tab andersom. */
  function focusables() {
    return Array.prototype.filter.call(dlg.querySelectorAll('a[href], button, textarea, input'), function (n) {
      if (n.disabled || n.closest('[hidden]') || !n.getClientRects().length) return false;
      return n.type !== 'radio' || n.checked;
    });
  }
  dlg.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
  });
  /* De keuze van de context sluit na Enter, Spatie of een klik; met de pijltjes blijf je in de lijst. */
  dlg.addEventListener('keydown', function (e) {
    if (e.target.name === 'pfadv-ctx' && (e.key === 'Enter' || e.key === 'Escape')) {
      e.preventDefault(); $('[data-adv-ctxlist]').hidden = true;
      var b = $('[data-adv-edit]'); b.setAttribute('aria-expanded', 'false'); b.focus();
    }
  });
  dlg.addEventListener('pointerup', function (e) {
    if (e.target.closest && e.target.closest('.pfadv__ctxopt')) setTimeout(function () { $('[data-adv-ctxlist]').hidden = true; var b = $('[data-adv-edit]'); b.setAttribute('aria-expanded', 'false'); }, 0);
  });
  text.addEventListener('input', function () { grow(); build(); });
  send.addEventListener('click', build);

  /* Eén klikafhandeling voor alle adviesknoppen. Een link houdt zijn href als terugval zonder JavaScript of met Ctrl/Cmd. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-advice-context]');
    if (!t || dlg.contains(t)) return;
    if (t.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;
    e.preventDefault();
    e.stopPropagation();
    open(t);
  }, true);
  window.pfAdvice = { open: function (ctx, data) { var t = document.createElement('span'); t.dataset.adviceContext = ctx || 'algemeen'; Object.keys(data || {}).forEach(function (k) { t.dataset[k] = data[k]; }); open(t); }, close: close, status: status }; // status: true/false binnen/buiten openingstijden, null zonder openingstijden

  /* FAQ-link #pf-faq=<vraag>: de vraag op deze pagina openklappen en in beeld brengen. */
  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function openFaq() {
    var m = location.hash.match(/^#pf-faq=(.+)$/); if (!m) return false;
    var q; try { q = norm(decodeURIComponent(m[1])); } catch (e) { return false; }
    var hit = Array.prototype.find.call(document.querySelectorAll('details > summary'), function (s) { return norm(s.textContent) === q; });
    if (!hit) return false;
    hit.parentElement.open = true;
    hit.scrollIntoView({ block: 'center' });
    try { hit.focus({ preventScroll: true }); } catch (e) { hit.focus(); }
    return true;
  }
  window.addEventListener('hashchange', openFaq);
  if (!openFaq()) window.addEventListener('load', openFaq, { once: true });
})();
